module.exports = __webpack_public_path__ + "static/media/banner_horsebook-half.bef47918.png";